module.exports = __webpack_public_path__ + "img/vannkraft_paavirkning_vannfoeringsregulering.aa038d1f.jpg";